import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HamburgerService {
    title = 'Hamburger Service';

    private hamburgerVisible = false;

    showHamburger() {
        this.hamburgerVisible = true;
    }

    hideHamburger() {
        this.hamburgerVisible = false;
    }

    isHamburgerVisible() {
        return this.hamburgerVisible;
    }
}
